import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './JobOfferArticle.module.scss';
import ArticleHeader from '../ArticleHeader/ArticleHeader';
import Article from 'common/components/Article/Article';
import ArticleContent from '../ArticleContent/ArticleContent';

import DefaultBackground from 'common/images/header_photo_job_offer.jpg';

export default class JobOfferArticle extends Component {
  static propTypes = {
    article: PropTypes.object.isRequired,
    bgPhoto: PropTypes.string.isRequired,
    rodoClause: PropTypes.string.isRequired,
    traffitFormLink: PropTypes.string.isRequired,
    apply: PropTypes.string.isRequired
  };

  static defaultProps = {
    className: ''
  };

  constructor(props) {
    super(props);

    this.state = {
      article: props.article
    };
  }

  static getDerivedStateFromProps(props, store) {
    return {
      article: props.article
    };
  }

  render() {
    const { className, bgPhoto, rodoClause } = this.props;
    const { article } = this.state;
    const articleHeaderData = {
      name: article.title,
      logo: article.logo,
      background: bgPhoto || DefaultBackground,
      cities: article.jobLocation.split(','),
      traffitFormLink: this.props.traffitFormLink,
      apply: this.props.apply
    };

    return (
      <div className={className}>
        <Article>
          <ArticleHeader
            {...articleHeaderData}
            className={styles.MarginBottom}
          />
          <ArticleContent article={article} rodoClause={rodoClause} />
        </Article>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/JobOfferArticle/components/Article/JobOfferArticle/JobOfferArticle.js